import { notification } from 'antd';
import type { AxiosError } from 'axios';
import axios from 'axios';

interface Config {
  title?: string;
}

export const error = (err: AxiosError | Error, cfg: Config = {}) => {
  let message = 'Что-то пошло не так, попробуйте позже';
  if (axios.isAxiosError(err)) {
    const { response } = err as AxiosError<{ message: string }>;
    if (response?.data?.message) {
      message = response.data.message;
    }
  }
  notification.open({
    message: cfg.title ?? 'Ошибка',
    description: message,
    type: 'error',
    duration: 5,
  });
};
